export default __webpack_public_path__ + "static/media/whitehat-blue.723f8554.svg";